<template>
  <div 
    class="main-table" 
    ref="MainTable">
    <el-table
      v-loading="loading"
      :data="listData"
      element-loading-text="加载中"
      border
      fit
      highlight-current-row
      :class="{'need-fixed': needFixed}"
      >
      <slot></slot>
    </el-table>

    <div class="page">
      <el-pagination
        size="small"
        @size-change="size => pageSizeChange(size)"
        @current-change="page => pageHandler(page)"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { withLoadingApi } from '@/utils/hoc'
import { scrollTo } from '@/utils'
const PageSizesKey = 'PAGE_SIZES_KEY';
export default {
  name: 'default',
  data () {
    return {
      page: 1,
      total: 0,
      listData: [],
      loading: false,
      pageSize: 0,

      needFixed: false
    }
  },
  props: {
    id: {
      type: Number,
      required: false,
      default: null
    },
    dataApi: {
      type: Function,
      required: true,
    },
    filter: {
      type: Object,
      required: false,
      default: () => ({})
    },
    pageSizes: {
      type: Array,
      required: false,
      default: () => [10, 20, 30, 50]
    }
  },
  methods: {
    initData(filter = {}, callback = null){
      withLoadingApi(this.dataApi({...{ page: this.page, limit: this.pageSize }, ...this.filter, ...filter}), 'loading', this).then(res => {
        let { list, total } = res;
        this.listData = list;
        this.total = total;
        callback && callback(res);
      })
    },
    localPageSize(){
      const key = this.id ? `${this.$route.fullPath}&id=${this.id}` : this.$route.fullPath;
      return {
        get: () => {
          let localData = JSON.parse(localStorage.getItem(PageSizesKey)) || null;
          return localData && localData instanceof Object ? localData[key] : null;
        },
        set: (val) => {
          let localData = JSON.parse(localStorage.getItem(PageSizesKey));
          localData = localData && localData instanceof Object ? localData : {};
          localStorage.setItem(PageSizesKey, JSON.stringify({ ...localData, ...{[`${key}`] : val }}));
        }
      }
    },
    pageSizeChange(size){
      this.pageSize = size;
      this.initData();
    },
    pageHandler(page){
      this.page = page;
      this.initData({}, () => {
        scrollTo(this.$refs.MainTable.offsetTop - 50);
      });
    },
    scrollEvent(type){
      if(type === 'add'){
        window.addEventListener('scroll', this.isNeedFixed)
      }else if(type === 'remove'){
        window.removeEventListener('scroll', this.isNeedFixed)
      }
    },
    isNeedFixed(){
      let st = document.documentElement.scrollTop;
      let posi = this.$refs.MainTable.offsetTop;
      if(st >= posi && !this.needFixed)
        this.needFixed = true;
      else if(st < posi && this.needFixed)
        this.needFixed = false;
    }
  },
  beforeDestroy(){
    this.scrollEvent('remove');
  },
  mounted(){
    this.pageSize = this.localPageSize().get() || this.pageSizes[0];
    this.scrollEvent('add');
  }
}
</script>

<style lang="scss" scoped>
.main-table{
  >>> .el-table{
    border-color: #FFFFFF;

    .el-table__header{
      th{
        background-color: #F2F2F2;
        border-color: #F2F2F2;
        text-align: center;
        font-weight: bold;
        color: $text1;
      }
    }

    .el-table__body{
      td{
        border-color: #FFFFFF;
        text-align: center;
      }
    }

    &:after{
      background-color: transparent;
    }

    &.need-fixed{
      .el-table__header-wrapper{
        position: fixed;
        z-index: 1;
        top: 50px;
      }

      .el-table__body-wrapper{
        margin-top: 50px;
      }
    }
  }

  .page{
    text-align: center;
    margin: 25px auto 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/MainTable.vue